
    export var PACKAGE_SOURCE = 'components';
    export var PACKAGE_VERSION = '3.0.0 (f411eac)';
    export var THEME = 'polaris';
    export var ALWAYS_VISUAL_REFRESH = false;
    